<template>
  <v-container grid-list-xl>
    <admin-navigation></admin-navigation>
    <br/>
    <v-row>
      <v-col cols="12" sm="12" class="pb-0">
        <v-card class="elevation-0">
          <v-card-title
            class="ma-0 pa-4 orange lighten-3 font-weight-black headline"
            style="overflow: hidden"
          >
            <span class="ml-4" style="text-transform: uppercase;">Recent Quotes</span>
            <span class="caption mt-2 ml-2">Showing recent 1000</span>
            <v-spacer></v-spacer>
            <v-btn small color="primary" outlined @click="getCsv" v-show="quotes.length">
              <v-icon left>download</v-icon>Export Report
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-4 px-1">
            <v-skeleton-loader type="table" v-if="loading"></v-skeleton-loader>
            <v-container fluid>
              <v-row>
                <v-col cols="12" class="py-0" v-if="!loading">
                  <v-data-table
                    :headers="headers"
                    :items="quotes"
                    :search="search"
                    item-key="key"
                    :items-per-page="100"
                  >
                    <template v-slot:top>
                      <v-row class="px-2 pt-2" align="center" no-gutters>
                        <v-col cols="12" sm="8" md="10">
                          <v-text-field
                            v-model="search"
                            outlined
                            label="Filter by client or email or job details"
                            dense
                          ></v-text-field>
                        </v-col>

                        <v-spacer />

                        <v-col cols="12" sm="4" md="2" class="d-flex align-center justify-end">
                          <v-switch
                            v-model="showModels"
                            inset
                            class="ma-0"
                            label="Show Model(s)"
                          />
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:item.domain="{ item }">
                      {{ item.createdBy.domain.split(".")[0] }}
                    </template>
                    <template v-slot:item.equipmentSummarySubtotal="{ item }">
                      ${{
                        Number(item.equipmentSummarySubtotal).toLocaleString(
                          "en-US"
                        )
                      }}
                      <span
                        class="caption grey--text d-block"
                        v-if="
                          item.equipmentSummarySubtotal !==
                          item.equipmentSummarySubtotalWithMarkup
                        "
                      >
                        ${{
                          Number(
                            item.equipmentSummarySubtotalWithMarkup
                          ).toLocaleString("en-US")
                        }}
                        with markup
                      </span>
                    </template>
                    <template v-slot:item.createDate="{ item }">
                      {{ item.createDate.toDate() | moment("M/D/YY") }}
                    </template>
                    <template v-slot:item.expirationDate="{ item }">
                      {{ new Date(item.expirationDate.seconds * 1000) | asUtc | moment("M/D/YY") }}
                    </template>
                    <template v-slot:item.date="{ item }">
                      {{ item.job.date | moment("M/D/YY") }}
                    </template>
                    <template v-slot:item.edit="{ item }">
                      <v-btn
                        color="primary"
                        text
                        outlined
                        x-small
                        class="mr-2"
                        @click="duplicateQuote(item)"
                      >
                        DUPLICATE
                      </v-btn>
                      <v-btn
                        color="primary"
                        text
                        outlined
                        x-small
                        class="mr-2"
                        target="_blank"
                        @click="generatePDFView(item)"
                        >VIEW</v-btn
                      >
                      <v-btn
                        color="primary"
                        text
                        outlined
                        x-small
                        class="mr-2"
                        target="_blank"
                        @click="generatePDF(item)"
                        >PDF</v-btn
                      >
                    </template>
                    <template slot="no-data">
                      <span class="grey--text text--darken-3">
                        You have not created any quotes yet. Click the
                        <strong>"Create New"</strong>
                        button above.
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snack = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import fb from "@/main";
import { mapGetters } from "vuex";
import { sortBy, uniq } from "lodash";
import AdminNavigation from "@/components/AdminNavigation.vue";

export default {
  components: {
    AdminNavigation
  },
  name: "Home",
  data() {
    return {
      dialogDelete: false,
      search: "",
      loading: false,
      dataExists: false,
      snack: false,
      snackColor: "",
      snackText: "",
      estDate: null,
      showModels: false,
      headers: [
        {
          text: "Quote #",
          value: "quoteReferenceNumber",
        },
        {
          text: "Model",
          value: "model",
        },
        {
          text: "User",
          value: "createdBy.email",
        },
        {
          text: "Client",
          value: "createdBy.domain",
        },
        {
          text: "Job",
          value: "job.jobName",
        },
        {
          text: "Created",
          value: "createDate"
        },
        {
          text: "Exp Date",
          value: "expirationDate"
        },
        {
          text: "Total",
          value: "equipmentSummarySubtotal",
        },
        {
          text: "",
          value: "edit",
          align: "end",
          width: 230
        },
      ],
      quotes: [],
    };
  },
  async created() {
    this.getQuotes();
  },
  watch: {
    showModels() {
      this.getQuotes();
    } 
  },
  computed: {
    formattedDate() {
      return this.job.date ? moment(this.job.date).format("MMMM Do YYYY") : "";
    },
    formattedEstDate() {
      return this.job.estDate
        ? moment(this.job.estDate).format("MMMM Do YYYY")
        : "";
    },
    ...mapGetters(["user"]),
  },
  methods: {
    async getQuotes() {
      try {
        this.loading = true;
        const quotesRes = await fb.db.collection("quotes").orderBy('createDate', 'desc').limit(1000).get()
        const quotes = [];
        quotesRes.forEach((q) => {
          const data = q.data();
          const equipment = Array.isArray(data.equipment) ? data.equipment : [];

          if (equipment.length && this.showModels) {
            // Extract unique model list
            const models = uniq(equipment.map(eq => eq.model).filter(Boolean));

            if (models.length) {
              models.forEach((model) => {
                quotes.push({
                  ...data,
                  id: q.id,
                  key: q.id + model,
                  model,   // unique model
                });
              });
            } else {
              // Equipment exists but no valid models
              quotes.push({
                ...data,
                id: q.id,
                key: q.id,
                model: "",
              });
            }
          } else {
            // No equipment at all
            quotes.push({
              ...data,
              id: q.id,
              key: q.id,
              model: "",
            });
          }
        });
        console.log("quotes", quotes);
        this.quotes = sortBy(quotes, "createDate").reverse();
        this.loading = false;
      } catch (error) {
        if (error.message === "Missing or insufficient permissions.") {
          this.$router.push("/");
        } else {
          alert("Error: ", error.message);
        }
      }
    },
    async duplicateQuote(quote) {
      if (confirm(`Are you sure you to duplicate this quote and save it to your ${this.user.email} account?`) == true) {
        try {
          this.loading = true;
          const dupe = { ...quote };

          dupe.job.jobName = "COPY " + (dupe.job.jobName || "");
          dupe.createDate = fb.timestamp;
          dupe.createdBy = this.user;

          // Get new quote reference number
          const getQuoteReferenceNumberCall = fb.functions.httpsCallable("getQuoteReferenceNumber");
          const quoteReferenceNumberRes = await getQuoteReferenceNumberCall();
          dupe.quoteReferenceNumber = quoteReferenceNumberRes.data;

          // Add new quote
          await fb.db.collection("quotes").add(dupe);

          // Refresh
          this.getQuotes();

          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Quote duplicated successfully.";
        } catch (error) {
          console.error("Error duplicating quote:", error);
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "Error duplicating quote.";
        } finally {
          this.loading = false;
        }
      }
    },
    generatePDFView(quote) {
      let url;
      if (location.hostname === "localhost") {
        url = `http://localhost:5001/gree-commercial/us-central1/generatePdf?id=${quote.id}&view=1`;
      } else {
        url = `https://us-central1-gree-commercial.cloudfunctions.net/generatePdf?id=${quote.id}&view=1`;
      }
      window.open(url, "_blank");
    },
    generatePDF(quote) {
      let url;
      if (location.hostname === "localhost") {
        url = `http://localhost:5001/gree-commercial/us-central1/generatePdf?id=${quote.id}`;
      } else {
        url = `https://us-central1-gree-commercial.cloudfunctions.net/generatePdf?id=${quote.id}`;
      }
      window.open(url, "_blank");
    },
    getCsv: function() {
      try {
        let quotesToExport = this.quotes;

        // If not showing models, deduplicate by ID to get one row per quote
        if (!this.showModels) {
          const uniqueQuotes = {};
          this.quotes.forEach((quote) => {
            if (!uniqueQuotes[quote.id]) {
              uniqueQuotes[quote.id] = quote;
            }
          });
          quotesToExport = Object.values(uniqueQuotes);
        }

        const csvData = [];
        quotesToExport.forEach((quote) => {
          const row = {
            "Quote #": quote.quoteReferenceNumber,
            User: quote.createdBy?.email || "",
            Client: quote.createdBy?.domain ? quote.createdBy.domain.split(".")[0] : "",
            Job: quote.job?.jobName || "",
            Created: quote.createDate ? moment(quote.createDate.toDate()).format("M/D/YY") : "",
            "Exp Date": quote.expirationDate ? moment(new Date(quote.expirationDate.seconds * 1000)).format("M/D/YY") : "",
            Total: quote.equipmentSummarySubtotal || 0,
          };

          // Add Model column when showing models
          if (this.showModels) {
            row.Model = quote.model || "";
          }

          csvData.push(row);
        });

        if (!csvData.length) {
          alert("No data was found. Try again.");
          return;
        }
        const replacer = (key, value) => (value === null ? "" : `${value}`);
        const header = Object.keys(csvData[0]);
        const csvFile = [
          header.join(","),
          ...csvData.map((row) =>
            header
              .map((fieldName) => JSON.stringify(row[fieldName], replacer))
              .join(",")
          ),
        ].join("\r\n");
        const filename = `quotes-${moment().format("YYYY-MM-DD")}.csv`;
        const blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, filename);
        } else {
          var link = document.createElement("a");
          if (link.download !== undefined) {
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      } catch (e) {
        alert("No data was found. Try again.");
        console.log("getCsv error", e);
      }
    },
  },
};
</script>
